// extracted by mini-css-extract-plugin
export var actions = "_1c-0";
export var actionsContainer = "_1c-6";
export var border = "_1c-1";
export var childFullHeight = "_1c-d";
export var collapse = "_1c-2";
export var content = "_1c-8";
export var contentChild = "_1c-c";
export var fullscreen = "_1c-a";
export var headerContainer = "_1c-3";
export var headerRow = "_1c-5";
export var hidePadding = "_1c-9";
export var noScrollX = "_1c-e";
export var noScrollY = "_1c-f";
export var optOutTopPadding = "_1c-b";
export var pagePadding = "_1c-7";
export var profile = "_1c-g";
export var profileContainer = "_1c-h";
export var profileImage = "_1c-i";
export var profileMain = "_1c-j";
export var profileSubtitle = "_1c-l";
export var profileTitle = "_1c-k";
export var tabsWrapper = "_1c-4";
export var title = "_1c-m";